// extracted by mini-css-extract-plugin
export var addressList = "jhL8pxzKBUtNoWfB4V5G";
export var helpText = "hbx_cF1xSsM6IeUuxUBG";